import { render } from "./ProjectSettings.vue?vue&type=template&id=98a73376"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"
script.render = render

export default script